import styled from 'styled-components'
import { Button } from 'antd'

export const StyledButton = styled(Button)`
  height: 40px;
  width: ${props=> props.mobile ? '100%' : '165px'};
  display: ${props=> props.mobile ? 'none' : 'flex'};
  justify-content: space-around;
  align-items: center;

  opacity: ${props => (props.disabled ? 0.6 : 1)} !important;
  border: 1px ${props => props.theme.OFI_PURPLE} !important;

  color: ${props =>
    props.disabled
      ? '#aca0a0'
      : props.isheader
      ? props.theme.PRIMARY_TEXT_COLOR
      : props.theme.WHITE} !important;
  background-color: ${props =>
    props.disabled
      ? '#e5eaf4'
      : props.isheader
      ? props.theme.WHITE
      : props.theme.PRIMARY_TEXT_COLOR} !important;
  @media screen and (max-width: 600px) {
    display: ${props=> props.mobile ? 'block': 'none'};
  }
`
export const Text = styled.span``
export const GifImage = styled.img`
  width: 34px;
  height: auto;
  background-color: ${props =>
    props.disabled
      ? props.theme.WHITE
      : props.theme.PRIMARY_TEXT_COLOR} !important;
`